var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('v-container',{staticClass:"pa-0 fill-height",attrs:{"fluid":""}},[(_vm.currentUser !== null && _vm.canUserViewStudy)?_c('DicomViewer'):_vm._e(),(_vm.currentUser !== null && !_vm.isStudyVisible)?_c('StudyNotFound'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }